import * as api from './adapter';
import { parseContentDispositionFilename } from '../parseContentDispositionFilename';

// Authed file download (for endpoints that stream a binary attachment).
// We can't use a bare <a href> — devise-token auth lives in headers, not
// cookies — so fetch with the standard auth headers, then save the blob
// under the server's filename (Content-Disposition) or the fallback.
const downloadFile = async (path, fallbackName) => {
  const res = await fetch(`/api/${path}`, {
    method: 'GET',
    headers: { ...api.getDefaultOptions().headers, Accept: '*/*' },
  });
  if (!res.ok) throw new Error(`Download failed: ${res.status}`);

  const blob = await res.blob();
  const name = parseContentDispositionFilename(res.headers.get('content-disposition')) || fallbackName;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export default downloadFile;
